module.exports = __webpack_public_path__ + "img/aave.900c8d1b.svg";